import axios from "@lib/axios";
import isServer from "@utils/is-server";

export async function postSubscription(body) {
  const res = await axios.post("subscription", body);
  return res.data.data;
}

export async function postChangeSubscriptionPlan() {
  const res = await axios.post("subscription/change_plan");
  return res.data.data;
}

export async function postPauseSubscription(body) {
  const res = await axios.post("subscription/pause", body);
  return res.data.data;
}

export async function postRestartSubscription() {
  const res = await axios.post("subscription/restart");
  return res.data.data;
}

export async function postCancelSuspension() {
  const res = await axios.post("subscription/cancel_suspension");
  return res.data.data;
}

export async function deleteSubscription(params) {
  const res = await axios.delete("subscription", { params });
  return res.data.data;
}

export async function getUnlockEarlyInformations() {
  const res = await axios.get("users/closets/unlock_early");

  return res.data;
}

export async function postUnlockEarly() {
  await axios.post("users/closets/unlock_early");
}

export async function getUnloggedSizes() {
  const res = await axios.get("sizes");
  return res.data;
}

export async function getProfile() {
  const res = await axios.get("profile");
  return res.data.data;
}

export async function putProfile(body) {
  const res = await axios.put("profile", body);
  return res.data.data;
}

export async function postUserPaymentMethod(setupIntentId) {
  const res = await axios.post("users/payment_method", { setup_intent: { id: setupIntentId } });
  return res.data.data;
}

export async function getProfileAttributes() {
  const res = await axios.get("profile/attributes");
  return res.data.data;
}

export async function putProfileAttributes(body) {
  const res = await axios.put("profile/attributes", body);
  return res.data.data;
}

export async function putUserFilterSizes(sizes) {
  const res = await axios.put("users/filters/sizes", sizes);
  return res.data.data;
}

export async function putUserSizeReference(sizeReference) {
  const res = await axios.put("users/size_reference", { size_reference: sizeReference });
  return res.data.data;
}

export async function putLanguage(lang) {
  const res = await axios.put("users/language", { lang: lang });
  return res.data;
}

export async function putUserTagTourGuide() {
  const res = await axios.put("users/tour_guide");
  return res.data.data;
}

export async function getUserProductsLiked() {
  const res = await axios.get("users/liked_products");
  return res.data.liked_products_ids;
}

export async function getUserProductsRented() {
  const res = await axios.get("users/rented_products");
  return res.data.rented_products_ids;
}

export async function getUserProductsLikedByToken(jwt) {
  if (!jwt) return null;

  const user = await fetch(
    `${isServer() && process.env.NEXT_PUBLIC_SERVER_SIDE_API_URL
      ? process.env.NEXT_PUBLIC_SERVER_SIDE_API_URL
      : process.env.NEXT_PUBLIC_API_URL
    }/users/liked_products`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${jwt}`,
        "X-App-Origin": "NextJs",
        "X-App-Version": process.env.HEROKU_RELEASE_VERSION,
      },
    },
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => data.liked_products_ids)
    .catch(() => null); // or [] ?

  return user;
}

export async function getUserProductsRentedByToken(jwt) {
  if (!jwt) return null;

  const user = await fetch(
    `${isServer() && process.env.NEXT_PUBLIC_SERVER_SIDE_API_URL
      ? process.env.NEXT_PUBLIC_SERVER_SIDE_API_URL
      : process.env.NEXT_PUBLIC_API_URL
    }/users/rented_products`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${jwt}`,
        "X-App-Origin": "NextJs",
        "X-App-Version": process.env.HEROKU_RELEASE_VERSION,
      },
    },
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => data.rented_products_ids)
    .catch(() => null); // or [] ?

  return user;
}
